"use client";

import Pagination from '@/reusablecomponents/Pagination';
import useViewType from '@/utils/Hooks/useViewType';
import { projectStrings } from '@/utils/projectstrings';
import TypoGraphy from '@/typography';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { RouteStrings } from '@/utils/routestrings';
import { projectImages } from 'public/Assets/Images';
import TopicCard from '@/reusablecomponents/TopicCard';
import './index.scss';
import TestimonialsSection from '@/reusablecomponents/TestimonialsSection';
import QuestionsSection from '@/components/freecourses/QuestionsSection';
import FaqSection from '@/reusablecomponents/FaqSection';
import { topicsFaqs } from '@/utils/staticdata';
import FreeCoursesSection from '@/components/freecourses/FreeCoursesSection';
import { API_ENDPOINTS } from '@/services/endPoints';
import { apiService } from '@/services/apiService';
import { AppContext } from '@/contexts/appcontext';
const TopicsPage = ({
  industries,
  subIndustriesData,
  testimonials,
  topics
}: any) => {
  const isMobile = useViewType();
  const [topicsData, settopicsData] = useState(topics);
  const [activeFilter, setactiveFilter] = useState("All");
  const [pageNo, setpageNo] = useState(1);
  const [touched, setTouched] = useState(false);
  const industriesForFilters: Array<string> = Array?.from(topics?.data?.reduce((set: Set<string>, item: any) => {
    const industryName = item?.attributes?.industry?.data?.attributes?.industryName;
    set.add(industryName);
    return set;
  }, new Set<string>()));
  const handleFilterClick = (filter: string) => {
    if (filter === activeFilter) return;
    setactiveFilter(filter);
  };
  const handlePageChange = (pageNo: number) => {
    setTouched(true);
    setpageNo(pageNo);
  };
  useEffect(() => {
    if (!touched) return;
    apiService(API_ENDPOINTS.APP_SERVER_URL + API_ENDPOINTS.getTopics(pageNo)).then((resp: any) => resp.json()).then((data: any) => settopicsData(data)).catch((error: any) => error?.response);
  }, [pageNo]);
  return <div className="topics_page_wrapper" data-sentry-component="TopicsPage" data-sentry-source-file="index.tsx">
            <div className="topics_heading_wrapper">
                <TypoGraphy text={projectStrings.topicHeading} variant={!isMobile ? 'Desktop/Heading 2' : 'Mobile/Heading'} tagName='h1' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                <TypoGraphy text={projectStrings.upskillSubheading} variant={isMobile ? 'Mobile/Body 1' : 'Desktop/Heading 1'} styles={{
        fontSize: isMobile ? "16px" : "",
        fontWeight: isMobile ? "400" : "",
        lineHeight: isMobile ? "135%" : ""
      }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            </div>
            <div className="industry_image_wrapper">
                <TypoGraphy text={projectStrings.companies} variant={isMobile ? 'Mobile/Body 2' : 'Desktop/Body 1/R | 16 |120'} styles={{
        textAlign: isMobile ? "center" : ""
      }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                <img src={isMobile ? projectImages.socialProofLogosMobile : projectImages.socialD} alt="companies" loading='lazy' style={{
        maxWidth: !isMobile ? "890px" : ""
      }} />
            </div>
            <div className="topics_data_wrapper">
                <div className="industry_filters_wrapper">
                    <a className={activeFilter === "All" ? "filter_item_active" : "filter_item"} title={'Learn All'} onClick={e => {
          e.preventDefault();
          handleFilterClick("All");
        }}>
                        <TypoGraphy text='All' variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 2/R | 14 |120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
                    </a>
                    {industriesForFilters?.map((industry: string, index: number) => {
          return <a href="#" title={`Learn ${industry}`} className={activeFilter?.toLowerCase().includes(industry?.toLowerCase()) ? "filter_item_active" : "filter_item"} key={`industry_index_${index}`} onClick={e => {
            e.preventDefault();
            handleFilterClick(industry);
          }}>
                                <TypoGraphy text={industry} variant={isMobile ? 'Mobile/Body 2/R | 14 | 120' : 'Desktop/Body 2/R | 14 |120'} />
                            </a>;
        })}
                </div>
                <div className="topics_wrapper">
                    {topicsData.data.filter((topic: any, index: number) => {
          if (isMobile && index > 10) return false;
          if (activeFilter === "All") return true;
          const industryName = topic?.attributes?.industry?.data?.attributes?.industryName;
          return activeFilter.toLowerCase().includes(industryName?.toLowerCase());
        }).map((topic: any, index: number) => {
          const premium = false;
          const data = topic?.attributes;
          // (index === 3 || index === 34 || index === 15) ? true : topic.isPremium
          return <div className="" key={`topic_card_${index}`} style={premium ? {
            display: "grid",
            gridColumn: "span 2",
            width: "100%"
          } : {}}>
                                <TopicCard isPremium={premium} data={data} href={RouteStrings.DYNAMICROUTE(data?.topicName, 'TOPICDETAIL', topic?.id)} />
                            </div>;
        })}
                </div>
            </div>
            {<div className="topics_pagination_wrapper">
                <Pagination pageCount={topicsData?.meta?.pagination?.pageCount} pageNo={pageNo} onPageChange={handlePageChange} />
            </div>}
            <div className="topic_testimonial_wrapper" style={{
      marginRight: !isMobile ? "-153px" : ""
    }}>
                <TestimonialsSection data={testimonials} title={projectStrings.learners} type={'TESTIMONIAL'} data-sentry-element="TestimonialsSection" data-sentry-source-file="index.tsx" />
            </div>
            <QuestionsSection data-sentry-element="QuestionsSection" data-sentry-source-file="index.tsx" />
            <FaqSection data={topicsFaqs} data-sentry-element="FaqSection" data-sentry-source-file="index.tsx" />
            {industries && <FreeCoursesSection data={industries} subIndustriesData={subIndustriesData} />}
        </div>;
};
export default TopicsPage;